import React from "react";
import style from "./PillarsCard.module.css";

function PillarsCard({data}) {

    return(

        <div className={style.PillarsCard_container} data-aos="fade-up" data-aos-duration="1200" data-aos-offset="40">
            <div style={{marginBottom: "1rem"}}>
                <img src={data.icon} alt={data.heading} />
            </div>
            <div className={style.PillarsCard_content}>
                <h5>{data.heading}</h5>
                <p>{data.content}</p>
            </div>
        </div>
    );
}

export default PillarsCard;

